import React, {
    useMemo,
    useState
} from 'react';

import {
    useNavigate
} from 'react-router-dom';

import HeaderUno from '../../Metodos/Compartidos/HeaderUno.js';

import {
    Cuerpo
} from '../../Css/StyledHeader.js';

import {
    HeaderTutorialesFijo,
    EspacioHeaderTutoriales,

    TutorialesMain,
    TutorialesIntroduccion,
    BuscadorTutoriales,
    IconoBuscador,
    InputBuscador,

    SeccionTutoriales,
    TituloSeccion,

    EncabezadoTutoriales,
    TituloTutoriales,

    GridTutoriales,
    TarjetaTutorial,
    ImagenTutorial,
    BotonPlay,
    BadgePopular,
    DuracionTutorial,
    InformacionTutorial,
    NombreTutorial,
    DescripcionTutorial,

    TabsTutoriales,
    TabTutorial,
    PanelTutoriales,

    MensajeSinResultados,

    SeccionFaq,
    FaqItem,
    FaqPregunta,
    FaqRespuesta,

    CursoBox,
    CursoTexto,
    BotonCurso,

    OverlayModalTutorial,
    ModalTutorial,
    ReproductorTutorial,
    IframeTutorial,
    ReproductorPlaceholder,
    PlayGrande,
    ModalTutorialInfo,
    ModalTutorialTexto,
    ModalTutorialTitulo,
    ModalTutorialDescripcion,
    BotonCerrarTutorial

} from '../../Css/StyledTutoriales.js';


/*
====================================
TUTORIALES
====================================

youtubeId:
Cuando tengamos el video real,
solamente hay que colocar el ID
del video de YouTube.

Ejemplo:

https://www.youtube.com/watch?v=ABC12345678

youtubeId: 'ABC12345678'

====================================
*/


const TUTORIALES_PLATAFORMA = [

    {
        id: 'demo-gratuita',
        titulo: 'Demo gratuita',
        descripcion: 'Conocé cómo funciona la demo gratuita de Método YÖGEN.',
        duracion: '1:34',
        categoria: 'plataforma',
        popular: true,
        youtubeId: 'hFYNL7iSRJI'
    },

    {
        id: 'crear-paciente',
        titulo: 'Cómo crear un paciente',
        descripcion: 'Aprendé a crear un paciente nuevo dentro de la plataforma.',
        duracion: '2:02',
        categoria: 'plataforma',
        popular: true,
        youtubeId: '1sVDGUfhfAE'
    },

    {
        id: 'invitar-paciente',
        titulo: 'Cómo invitar a un paciente',
        descripcion: 'Aprendé a invitar a un paciente para que pueda utilizar Método YÖGEN.',
        duracion: '2:11',
        categoria: 'plataforma',
        popular: true,
        youtubeId: 'owCznqrplqk'
    },

    {
        id: 'suscripcion',
        titulo: 'Cómo suscribirme al Método',
        descripcion: 'Te mostramos cómo realizar la suscripción a Método YÖGEN.',
        duracion: '2:23',
        categoria: 'plataforma',
        popular: true,
        youtubeId: 'DeKsTpzUboE'
    },

    {
        id: 'anamnesis',
        titulo: 'Cómo crear y exportar una anamnesis',
        descripcion: 'Aprendé a completar la anamnesis de un paciente y exportarla.',
        duracion: '3:51',
        categoria: 'plataforma',
        popular: false,
        youtubeId: 'NzLkeUGWNxo'
    },

    {
        id: 'turnos',
        titulo: 'Cómo asignar un turno',
        descripcion: 'Aprendé a crear y asignar turnos desde el calendario.',
        duracion: '2:56',
        categoria: 'plataforma',
        popular: false,
        youtubeId: '_SHe4REkXRM'
    },

    {
        id: 'historia-clinica',
        titulo: 'Historia clínica',
        descripcion: 'Conocé cómo utilizar la historia clínica dentro de la plataforma.',
        duracion: '1:32',
        categoria: 'plataforma',
        popular: false,
        youtubeId: '_E-i42VR0oA'
    },

    {
        id: 'consultorios',
        titulo: 'Cómo agregar consultorios',
        descripcion: 'Aprendé a agregar tus consultorios o sedes desde tu perfil.',
        duracion: '1:22',
        categoria: 'plataforma',
        popular: false,
        youtubeId: 'ekFxwDKqWVY'
    },

    {
        id: 'objetivos',
        titulo: 'Cómo asignar objetivos',
        descripcion: 'Aprendé a asignar objetivos de trabajo a tus pacientes.',
        duracion: '1:22',
        categoria: 'plataforma',
        popular: false,
        youtubeId: 'vRiEtayDhnM'
    },

    {
        id: 'crear-cuenta-profesional',
        titulo: 'Cómo crear una cuenta profesional',
        descripcion: 'Te mostramos cómo crear tu cuenta profesional en Método YÖGEN.',
        duracion: '2:56',
        categoria: 'plataforma',
        popular: false,
        youtubeId: 'AdtuA940F54'
    },

    {
        id: 'manual-cobros-pacientes',
        titulo: 'Gestión de cobros de pacientes',
        descripcion: 'Guía completa para registrar, controlar y corregir los cobros de tus pacientes.',
        categoria: 'plataforma',
        popular: true,
        tipo: 'manual',
        ruta: '/escritorio/tutoriales/cobros-pacientes'
    },

    {
        id: 'manual-cobros-centros',
        titulo: 'Centros y liquidaciones',
        descripcion: 'Guía completa para configurar centros, calcular honorarios y registrar pagos.',
        categoria: 'plataforma',
        popular: true,
        tipo: 'manual',
        ruta: '/escritorio/tutoriales/cobros-centros'
    }

];


const TUTORIALES_EJERCICIOS = [

    {
        id: 'activar-metodo-parte-1',
        titulo: 'Cómo activar el Método en un paciente — Parte 1',
        descripcion: 'Aprendé cómo activar Método YÖGEN en uno de tus pacientes.',
        duracion: '2:01',
        categoria: 'ejercicios',
        popular: true,
        youtubeId: 'l5JJnl_B-1s'
    },

    {
        id: 'activar-metodo-parte-2',
        titulo: 'Cómo activar el Método en un paciente — Parte 2',
        descripcion: 'Conocé las principales funcionalidades disponibles una vez activado el Método.',
        duracion: '2:38',
        categoria: 'ejercicios',
        popular: true,
        youtubeId: 'hdQDorRgxNk'
    },

    {
        id: 'ejercicios',
        titulo: 'Exploramos los ejercicios del Método',
        descripcion: 'Recorré los ejercicios disponibles y conocé cómo están organizados.',
        duracion: '5:44',
        categoria: 'ejercicios',
        popular: true,
        youtubeId: '_yIr3jSWfW0'
    },

    {
        id: 'asignar-actividades-domicilio-parte-1',
        titulo: 'Asignar actividades a domicilio — Parte 1',
        descripcion: 'Aprendé a asignarle actividades para realizar en casa a tu paciente.',
        duracion: '2:35',
        categoria: 'ejercicios',
        popular: false,
        youtubeId: '0_Shbd-h4Gw'
    },

    {
        id: 'asignar-actividades-domicilio-parte-2',
        titulo: 'Asignar actividades a domicilio — Parte 2',
        descripcion: 'Mirá cómo visualiza el paciente las actividades que le asignaste.',
        duracion: '0:56',
        categoria: 'ejercicios',
        popular: false,
        youtubeId: '0M3GTUsfv5U'
    },

    {
        id: 'resultados',
        titulo: 'Cómo ver los resultados de los ejercicios',
        descripcion: 'Aprendé a consultar los resultados de los ejercicios realizados por tus pacientes.',
        duracion: '1:44',
        categoria: 'ejercicios',
        popular: false,
        youtubeId: 'ilf72-mL5Bk'
    }

];


/*
====================================
PREGUNTAS FRECUENTES
====================================
*/

const PREGUNTAS_FRECUENTES = [

    {
        id: 'faq-demo-gratuita',
        pregunta: '¿Puedo probar Método YÖGEN antes de suscribirme?',
        respuesta:
            'Sí. Podés usar la demo gratuita para conocer la plataforma y probar las actividades. Te recomendamos hacerlo antes de suscribirte, para ver si los recursos se adaptan a tus pacientes y a tu forma de trabajo.'
    },

    {
        id: 'faq-edades',
        pregunta: '¿Para qué edades está pensado Método YÖGEN?',
        respuesta:
            'Está pensado para trabajar desde aproximadamente los 5 años en adelante. La edad depende también de las habilidades y necesidades de cada paciente. Seguimos incorporando nuevas actividades y contenidos.'
    },

    {
        id: 'faq-que-puedo-trabajar',
        pregunta: '¿Qué puedo trabajar en la plataforma?',
        respuesta:
            'Encontrás actividades para trabajar lectura, escritura, matemática y diferentes habilidades relacionadas con el aprendizaje. Los recursos están organizados para que el profesional pueda seleccionar las actividades según las necesidades de cada paciente.'
    },

    {
        id: 'faq-funciones-gratuitas',
        pregunta: '¿Qué funciones son gratuitas?',
        respuesta:
            'Podés usar de manera gratuita la anamnesis y los objetivos de trabajo. Para utilizar los ejercicios y las demás funciones de Método YÖGEN necesitás una suscripción.'
    },

    {
        id: 'faq-suscripcion-mensual',
        pregunta: '¿La suscripción es mensual?',
        respuesta:
            'Sí. La suscripción es mensual y se renueva automáticamente. El cobro mensual se realiza entre los días 1 y 6 de cada mes.'
    },

    {
        id: 'faq-suscripcion-mitad-mes',
        pregunta: 'Si me suscribo a mitad de mes, ¿pago el mes completo?',
        respuesta:
            'No. El primer mes se cobra solamente la parte correspondiente a los días que quedan del mes. A partir del mes siguiente, se cobra el valor mensual completo de tu plan.'
    },

    {
        id: 'faq-pausar-suscripcion',
        pregunta: '¿Puedo pausar mi suscripción?',
        respuesta:
            'Sí. Podés pausar la suscripción cuando lo necesites y volver a activarla más adelante.'
    },

    {
        id: 'faq-pacientes-pausa-suscripcion',
        pregunta: '¿Pierdo a mis pacientes si pauso la suscripción?',
        respuesta:
            'No. Pausar la suscripción no elimina a tus pacientes. Cuando vuelvas a activar tu plan, vas a poder retomar el trabajo con la información guardada. La conservación de los datos se realiza según los plazos establecidos por la plataforma.'
    },

    {
        id: 'faq-correo-paciente',
        pregunta: '¿Necesito un correo electrónico para crear un paciente?',
        respuesta:
            'Sí. Cada paciente necesita un correo electrónico real. Ese correo permite identificar al paciente dentro de la plataforma y asociarlo con su información e historia clínica. Si el niño todavía no tiene correo, la familia puede crear uno para él.'
    },

    {
        id: 'faq-cuenta-padres',
        pregunta: '¿Los padres tienen que crear una cuenta?',
        respuesta:
            'No. Los padres no necesitan crear un usuario. El profesional crea y administra al paciente desde su propia cuenta. Cuando corresponde, la plataforma solicita la autorización de la familia.'
    },

    {
        id: 'faq-pago-padres',
        pregunta: '¿Los padres tienen que pagar la plataforma?',
        respuesta:
            'No. La suscripción la paga únicamente el profesional. Cada profesional puede decidir si incluye este costo dentro de sus honorarios o si cobra un adicional a las familias.'
    },

    {
        id: 'faq-crear-paciente',
        pregunta: '¿Cómo creo un paciente?',
        respuesta:
            'Desde tu cuenta ingresá a Pacientes y elegí la opción para crear un nuevo paciente. Vas a necesitar sus datos y un correo electrónico real. También tenés un tutorial paso a paso dentro de la plataforma.'
    },

    {
        id: 'faq-archivado',
        pregunta: '¿Cómo recupero un paciente que archivé por error?',
        respuesta:
            'Podés ingresar a tus pacientes archivados y volver a activarlo. No necesitás crear un paciente nuevo.'
    },

    {
        id: 'faq-consultorios',
        pregunta: '¿Puedo tener más de un consultorio cargado?',
        respuesta:
            'Sí. Podés cargar distintos consultorios o lugares de atención y utilizarlos al organizar tus turnos.'
    }

];


/*
====================================
NORMALIZAR TEXTO PARA BÚSQUEDA
====================================

Permite encontrar, por ejemplo:

"suscripcion"

aunque el tutorial tenga:

"suscripción"

====================================
*/

const normalizarTexto = (texto = '') => {

    return texto
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

};


/*
====================================
COMPONENTE
====================================
*/

const Tutoriales = () => {

    const navigate = useNavigate();

    const [categoriaActiva, setCategoriaActiva] = useState('plataforma');

    const [busqueda, setBusqueda] = useState('');

    const [tutorialSeleccionado, setTutorialSeleccionado] = useState(null);

    const [faqAbierta, setFaqAbierta] = useState(null);


    /*
    ====================================
    TODOS LOS TUTORIALES
    ====================================
    */

    const todosLosTutoriales = useMemo(() => {

        return [
            ...TUTORIALES_PLATAFORMA,
            ...TUTORIALES_EJERCICIOS
        ];

    }, []);


    /*
    ====================================
    MÁS BUSCADOS
    ====================================
    */

    const tutorialesMasBuscados = useMemo(() => {

        return todosLosTutoriales.filter(
            (tutorial) => tutorial.popular
        );

    }, [todosLosTutoriales]);


    /*
    ====================================
    BÚSQUEDA
    ====================================
    */

    const busquedaNormalizada = normalizarTexto(
        busqueda.trim()
    );


    const buscando = busquedaNormalizada.length > 0;


    const tutorialesFiltrados = useMemo(() => {

        if (!busquedaNormalizada) {
            return [];
        }

        return todosLosTutoriales.filter((tutorial) => {

            const textoTutorial = normalizarTexto(
                `${tutorial.titulo} ${tutorial.descripcion}`
            );

            return textoTutorial.includes(
                busquedaNormalizada
            );

        });

    }, [
        todosLosTutoriales,
        busquedaNormalizada
    ]);


    const preguntasFiltradas = useMemo(() => {

        if (!busquedaNormalizada) {
            return [];
        }

        return PREGUNTAS_FRECUENTES.filter((faq) => {

            const textoFaq = normalizarTexto(
                `${faq.pregunta} ${faq.respuesta}`
            );

            return textoFaq.includes(
                busquedaNormalizada
            );

        });

    }, [busquedaNormalizada]);


    /*
    ====================================
    MODAL DE VIDEO
    ====================================
    */

    const abrirTutorial = (tutorial) => {

        /*
        ====================================
        MANUALES
        ====================================

        Los manuales no abren el modal
        de video.

        Navegan a su propia página.
        ====================================
        */

        if (
            tutorial.tipo === 'manual' &&
            tutorial.ruta
        ) {

            navigate(
                tutorial.ruta
            );

            return;

        }


        /*
        ====================================
        VIDEOS
        ====================================
        */

        setTutorialSeleccionado(
            tutorial
        );

    };


    const cerrarTutorial = () => {

        setTutorialSeleccionado(null);

    };


    /*
    ====================================
    FAQ
    ====================================
    */

    const toggleFaq = (idFaq) => {

        setFaqAbierta((actual) => {

            if (actual === idFaq) {
                return null;
            }

            return idFaq;

        });

    };


    /*
    ====================================
    TARJETA
    ====================================

    La misma tarjeta se reutiliza en:

    - más buscados
    - plataforma
    - ejercicios
    - resultados de búsqueda

    ====================================
    */

    const renderTarjetaTutorial = (
        tutorial,
        mostrarPopular = false
    ) => {

        return (

            <TarjetaTutorial
                key={`${tutorial.categoria}-${tutorial.id}`}
                onClick={() => abrirTutorial(tutorial)}
            >

                <ImagenTutorial
                    $categoria={tutorial.categoria}
                >

                    {mostrarPopular && tutorial.popular ? (

                        <BadgePopular>
                            🔥 Popular
                        </BadgePopular>

                    ) : null}


                    <BotonPlay>

                        {tutorial.tipo === 'manual' ? (

                            <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.8"
                            >
                                <path
                                    d="M4 5.5A2.5 2.5 0 0 1 6.5 3H11v16H6.5A2.5 2.5 0 0 0 4 21.5V5.5Z"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />

                                <path
                                    d="M20 5.5A2.5 2.5 0 0 0 17.5 3H13v16h4.5a2.5 2.5 0 0 1 2.5 2.5V5.5Z"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>

                        ) : (

                            <svg
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M8 5v14l11-7z" />
                            </svg>

                        )}

                    </BotonPlay>


                    <DuracionTutorial>

                        {tutorial.tipo === 'manual'
                            ? 'Manual'
                            : tutorial.duracion
                        }

                    </DuracionTutorial>

                </ImagenTutorial>


                <InformacionTutorial>

                    <NombreTutorial>
                        {tutorial.titulo}
                    </NombreTutorial>


                    <DescripcionTutorial>
                        {tutorial.descripcion}
                    </DescripcionTutorial>

                </InformacionTutorial>

            </TarjetaTutorial>

        );

    };


    /*
    ====================================
    RENDER
    ====================================
    */

    return (

        <Cuerpo>

            <HeaderTutorialesFijo>

                <HeaderUno />

            </HeaderTutorialesFijo>

            <EspacioHeaderTutoriales />

            <TutorialesMain>

                <EncabezadoTutoriales>

                    <TituloTutoriales>
                        TUTORIALES
                    </TituloTutoriales>

                </EncabezadoTutoriales>


                <TutorialesIntroduccion>
                    Videos y guías prácticas para aprender a utilizar la plataforma
                    y aprovechar las distintas herramientas de Método YÖGEN.
                </TutorialesIntroduccion>


                {/*
                ====================================
                BUSCADOR
                ====================================
                */}

                <BuscadorTutoriales>

                    <IconoBuscador>

                        <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                        >

                            <circle
                                cx="11"
                                cy="11"
                                r="7"
                            />

                            <path
                                d="m21 21-4.3-4.3"
                                strokeLinecap="round"
                            />

                        </svg>

                    </IconoBuscador>


                    <InputBuscador
                        type="text"
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                        placeholder='Buscar un tutorial (ej: "archivar paciente", "anamnesis"...)'
                    />

                </BuscadorTutoriales>


                {/*
                ====================================
                CONTENIDO NORMAL
                ====================================
                */}

                {!buscando ? (

                    <>

                        {/*
                        ====================================
                        MÁS BUSCADOS
                        ====================================
                        */}

                        <SeccionTutoriales>

                            <TituloSeccion>
                                Los más buscados
                            </TituloSeccion>


                            <GridTutoriales>

                                {tutorialesMasBuscados.map(
                                    (tutorial) => (
                                        renderTarjetaTutorial(
                                            tutorial,
                                            true
                                        )
                                    )
                                )}

                            </GridTutoriales>

                        </SeccionTutoriales>


                        {/*
                        ====================================
                        TABS
                        ====================================
                        */}

                        <TabsTutoriales>

                            <TabTutorial
                                type="button"
                                $activo={
                                    categoriaActiva === 'plataforma'
                                }
                                onClick={() =>
                                    setCategoriaActiva('plataforma')
                                }
                            >
                                Uso de la plataforma
                            </TabTutorial>


                            <TabTutorial
                                type="button"
                                $activo={
                                    categoriaActiva === 'ejercicios'
                                }
                                onClick={() =>
                                    setCategoriaActiva('ejercicios')
                                }
                            >
                                Ejercicios y contenido clínico
                            </TabTutorial>

                        </TabsTutoriales>


                        {/*
                        ====================================
                        PANEL
                        ====================================
                        */}

                        <PanelTutoriales>

                            <GridTutoriales>

                                {(categoriaActiva === 'plataforma'
                                    ? TUTORIALES_PLATAFORMA
                                    : TUTORIALES_EJERCICIOS
                                ).map(
                                    (tutorial) =>
                                        renderTarjetaTutorial(
                                            tutorial,
                                            false
                                        )
                                )}

                            </GridTutoriales>


                            {/*
                            ====================================
                            FAQ DE PLATAFORMA
                            ====================================
                            */}

                            {categoriaActiva === 'plataforma' ? (

                                <SeccionFaq>

                                    <TituloSeccion>
                                        Preguntas frecuentes
                                    </TituloSeccion>


                                    {PREGUNTAS_FRECUENTES.map(
                                        (faq) => {

                                            const abierta =
                                                faqAbierta === faq.id;

                                            return (

                                                <FaqItem
                                                    key={faq.id}
                                                >

                                                    <FaqPregunta
                                                        type="button"
                                                        $abierto={abierta}
                                                        onClick={() =>
                                                            toggleFaq(faq.id)
                                                        }
                                                    >

                                                        <span>
                                                            {faq.pregunta}
                                                        </span>


                                                        <svg
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="2.3"
                                                        >

                                                            <path
                                                                d="m6 9 6 6 6-6"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />

                                                        </svg>

                                                    </FaqPregunta>


                                                    <FaqRespuesta
                                                        $abierto={abierta}
                                                    >
                                                        {faq.respuesta}
                                                    </FaqRespuesta>

                                                </FaqItem>

                                            );

                                        }
                                    )}

                                </SeccionFaq>

                            ) : null}


                            {/*
                            ====================================
                            FORMACIÓN
                            ====================================
                            */}

                            {categoriaActiva === 'ejercicios' ? (

                                <CursoBox>

                                    <CursoTexto>

                                        <h3>
                                            ¿Querés ir más a fondo con el Método?
                                        </h3>

                                        <p>
                                            Estos videos te muestran el uso
                                            básico de los ejercicios y de la
                                            plataforma. Si necesitás información
                                            sobre las formaciones de Método YÖGEN,
                                            podés escribirnos.
                                        </p>

                                    </CursoTexto>


                                    <BotonCurso
                                        type="button"
                                        onClick={() =>
                                            navigate(
                                                '/escritorio/contacto'
                                            )
                                        }
                                    >
                                        Consultar por el curso →
                                    </BotonCurso>

                                </CursoBox>

                            ) : null}

                        </PanelTutoriales>

                    </>

                ) : null}


                {/*
                ====================================
                RESULTADOS DE BÚSQUEDA
                ====================================
                */}

                {buscando ? (

                    <SeccionTutoriales>

                        <TituloSeccion>
                            Resultados de búsqueda
                        </TituloSeccion>


                        {tutorialesFiltrados.length > 0 ? (

                            <GridTutoriales>

                                {tutorialesFiltrados.map(
                                    (tutorial) =>
                                        renderTarjetaTutorial(
                                            tutorial,
                                            false
                                        )
                                )}

                            </GridTutoriales>

                        ) : null}


                        {preguntasFiltradas.length > 0 ? (

                            <SeccionFaq>

                                <TituloSeccion>
                                    Preguntas frecuentes relacionadas
                                </TituloSeccion>


                                {preguntasFiltradas.map(
                                    (faq) => {

                                        const abierta =
                                            faqAbierta === faq.id;

                                        return (

                                            <FaqItem
                                                key={faq.id}
                                            >

                                                <FaqPregunta
                                                    type="button"
                                                    $abierto={abierta}
                                                    onClick={() =>
                                                        toggleFaq(faq.id)
                                                    }
                                                >

                                                    <span>
                                                        {faq.pregunta}
                                                    </span>


                                                    <svg
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2.3"
                                                    >

                                                        <path
                                                            d="m6 9 6 6 6-6"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />

                                                    </svg>

                                                </FaqPregunta>


                                                <FaqRespuesta
                                                    $abierto={abierta}
                                                >
                                                    {faq.respuesta}
                                                </FaqRespuesta>

                                            </FaqItem>

                                        );

                                    }
                                )}

                            </SeccionFaq>

                        ) : null}


                        {tutorialesFiltrados.length === 0 &&
                        preguntasFiltradas.length === 0 ? (

                            <MensajeSinResultados>

                                No encontramos tutoriales ni preguntas
                                frecuentes que coincidan con tu búsqueda.

                            </MensajeSinResultados>

                        ) : null}

                    </SeccionTutoriales>

                ) : null}

            </TutorialesMain>


            {/*
            ====================================
            MODAL DEL TUTORIAL
            ====================================
            */}

            {tutorialSeleccionado ? (

                <OverlayModalTutorial
                    onClick={cerrarTutorial}
                >

                    <ModalTutorial
                        onClick={(e) => e.stopPropagation()}
                    >

                        <ReproductorTutorial>

                            {tutorialSeleccionado.youtubeId ? (

                                <IframeTutorial
                                    src={`https://www.youtube.com/embed/${tutorialSeleccionado.youtubeId}?autoplay=1`}
                                    title={tutorialSeleccionado.titulo}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />

                            ) : (

                                <ReproductorPlaceholder>

                                    <PlayGrande>

                                        <svg
                                            viewBox="0 0 24 24"
                                            fill="currentColor"
                                        >
                                            <path d="M8 5v14l11-7z" />
                                        </svg>

                                    </PlayGrande>

                                    <span>
                                        Acá se va a reproducir el video
                                        cuando carguemos el tutorial.
                                    </span>

                                </ReproductorPlaceholder>

                            )}

                        </ReproductorTutorial>


                        <ModalTutorialInfo>

                            <ModalTutorialTexto>

                                <ModalTutorialTitulo>
                                    {tutorialSeleccionado.titulo}
                                </ModalTutorialTitulo>

                                <ModalTutorialDescripcion>
                                    {tutorialSeleccionado.descripcion}
                                </ModalTutorialDescripcion>

                            </ModalTutorialTexto>


                            <BotonCerrarTutorial
                                type="button"
                                onClick={cerrarTutorial}
                                aria-label="Cerrar tutorial"
                            >

                                <svg
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2.3"
                                >

                                    <path
                                        d="M6 6l12 12M18 6 6 18"
                                        strokeLinecap="round"
                                    />

                                </svg>

                            </BotonCerrarTutorial>

                        </ModalTutorialInfo>

                    </ModalTutorial>

                </OverlayModalTutorial>

            ) : null}

        </Cuerpo>

    );

};


export default Tutoriales;